import React from 'react';

/**
 * @param {{ showEnglish: boolean; isDark: boolean; prompts: { en: string; hi: string }[]; onSelect: (text: string) => void; disabled?: boolean; transparentShell?: boolean }} props
 */
export function BhriguSuggestedPrompts({
  showEnglish,
  isDark,
  prompts,
  onSelect,
  disabled = false,
  transparentShell = false,
}) {
  if (!prompts.length) return null;

  return (
    <div className="flex flex-wrap gap-2">
      {prompts.map((p, index) => {
        const text = showEnglish ? p.en : p.hi;
        const stagger = `bhrigu-stagger-${Math.min(index + 1, 8)}`;
        return (
          <button
            key={p.en}
            type="button"
            disabled={disabled}
            onClick={() => onSelect(text)}
            className={`bhrigu-prompt-in ${stagger} rounded-full border px-3 py-1 text-xs font-medium transition-[background-color,border-color,transform] duration-500 ease-[cubic-bezier(0.22,1,0.36,1)] hover:-translate-y-px disabled:opacity-50 disabled:hover:translate-y-0 ${
              transparentShell
                ? `ask-bhrigu-transparent-prompt ask-bhrigu-readable ${isDark ? 'text-violet-100' : 'text-violet-950'}`
                : isDark
                  ? 'border-violet-400/35 bg-violet-500/10 text-violet-100 hover:bg-violet-500/20'
                  : 'border-violet-300 bg-violet-50 text-violet-900 hover:bg-violet-100'
            } ${showEnglish ? '' : 'font-devanagari'}`}
            lang={showEnglish ? 'en' : 'hi'}
          >
            {text}
          </button>
        );
      })}
    </div>
  );
}
